import type { ProductType } from "@1js/pl-card-components";
import type { IPublicClientApplication } from "@azure/msal-browser";
import { buildCoreHeaders } from "../utils/header";
import { authAwareFetch } from "./fetch";

export interface IWorkingSetFilesBatchRecentFilesResponse {
  responses?: {
    id: string;
    status: number;
    body: {
      value?: [
        {
          Id: string;
          PrimaryItemLocation: string;
          FileName: string;
          WorkingSetId: string;
          SharePointItem: {
            FileUrl: string;
          };
          Visualization: {
            Type: string;
            AccessUrl: string;
          };
          ItemProperties: object;
        },
      ];
    };
  }[];
}

export type RecentFilesResponse = IWorkingSetFilesBatchRecentFilesResponse;

export type HandoffFile = {
  fileId: string;
  fileName: string;
  fileUrl: string;
};

export type RecentFiles = {
  [product in ProductType | string]: HandoffFile[];
};

const recentFilesAsync = async (
  host: string,
  locale: string,
  msalContext?: IPublicClientApplication
): Promise<RecentFilesResponse> => {
  const serviceUrl = `https://${host}/${locale}/api/promptsclient/workingsetfiles/recent`;

  const headers = await buildCoreHeaders(msalContext);
  headers.append(
    "RequestVerificationToken",
    document
      ?.querySelector('input[name="__RequestVerificationToken"]')
      ?.getAttribute("value") ?? ""
  );

  const response = await authAwareFetch(serviceUrl, {
    method: "GET",
    headers,
  });

  return (await response.json()) as RecentFilesResponse;
};

export const recentFilesByProductAsync = async (
  host: string,
  locale: string,
  isUseAccessUrlEnabled: boolean,
  msalContext?: IPublicClientApplication
): Promise<RecentFiles> => {
  const response = await recentFilesAsync(host, locale, msalContext);
  const recentFiles: RecentFiles = {
    Word: [],
    Excel: [],
    PowerPoint: [],
  };
  response.responses?.forEach((res) => {
    res.body.value?.forEach((file) => {
      const fileId = file.Id;
      const fileName = file.FileName;
      const fileUrl = isUseAccessUrlEnabled
        ? file.Visualization.AccessUrl ?? file.SharePointItem.FileUrl
        : file.SharePointItem.FileUrl;
      const product = file.Visualization.Type;
      if (product === "Word") {
        recentFiles.Word.push({ fileId, fileName, fileUrl });
      } else if (product === "Excel") {
        recentFiles.Excel.push({ fileId, fileName, fileUrl });
      } else if (product === "PowerPoint") {
        recentFiles.PowerPoint.push({ fileId, fileName, fileUrl });
      }
    });
  });
  return recentFiles;
};
